import React from "react";
import { useNavigate } from "react-router-dom";

function withAuth(Component) {
  return function WithAuth(props) {
    const token = localStorage.getItem("token");
    const navigate = useNavigate();

    if (!token) {
      navigate("/login");
      return null;
    }

    return <Component {...props} />;
  };
}

export default withAuth;
